import { Betslip } from '@/betCalculation/betslip'
import { IExportedBetslip } from '@/interfaces/betting'
import { EventFunctions } from '@altenar/models'

export default function exportBetslip(betslip: Betslip): IExportedBetslip {
  const exportedSelections: any[] = []
  const exportedSelectionIds = {}
  betslip.selectedOdds.forEach(odd => {
    exportedSelections.push(EventFunctions.createSelectionByOdd(odd))
  })
  betslip.selectedOddsIds.forEach(oddId => {
    exportedSelectionIds[oddId] = true
  })
  return {
    selections: exportedSelections,
    selectionIds: exportedSelectionIds,
    selectionStakes: Array(betslip.selectedOddsIds.length).fill(betslip.multipleStake),
    oddsChangeAction: 'Alwaysask',
    isDisableds: Array(betslip.selectedOddsIds.length).fill(false),
    bankerEventIds: [],
    combos: [betslip.multipleStake],
    multipleCombo: betslip.multipleStake,
    defaultUnitStake: 10,
    defaultFastStake: 0,
    mode: 'Multiple',
    selectionWins: [0],
    fullCover: ''
  }
}
